// =================================================================
// Quake II - Player Animation Frames
// Source: rerelease/m_player.h
// =================================================================

export const FRAME_stand01 = 0;
export const FRAME_stand40 = 39;

export const FRAME_run1 = 40;
export const FRAME_run6 = 45;

export const FRAME_attack1 = 46;
export const FRAME_attack8 = 53;

export const FRAME_pain101 = 54;
export const FRAME_pain104 = 57;

export const FRAME_pain201 = 58;
export const FRAME_pain204 = 61;

export const FRAME_pain301 = 62;
export const FRAME_pain304 = 65;

export const FRAME_death101 = 66;
export const FRAME_death106 = 71;

export const FRAME_death201 = 72;
export const FRAME_death206 = 77;

export const FRAME_death301 = 78;
export const FRAME_death306 = 83;

export const FRAME_crstnd01 = 84;
export const FRAME_crstnd19 = 102;

export const FRAME_crwalk1 = 103;
export const FRAME_crwalk6 = 108;

export const FRAME_crattak1 = 109;
export const FRAME_crattak3 = 111; // Derived
export const FRAME_crattak9 = 117;

export const FRAME_crpain1 = 118;
export const FRAME_crpain4 = 121;

export const FRAME_crdeath1 = 122;
export const FRAME_crdeath5 = 126;

export const FRAME_wave01 = 127;
export const FRAME_wave08 = 134; // Derived
export const FRAME_wave11 = 137;

export const FRAME_point01 = 138;
export const FRAME_point12 = 149;

export const FRAME_salute01 = 150;
export const FRAME_salute11 = 160;

export const FRAME_taunt01 = 161;
export const FRAME_taunt17 = 177;

export const FRAME_flip01 = 178;
export const FRAME_flip12 = 189;

export const FRAME_jump1 = 190;
export const FRAME_jump6 = 195;

export const FRAME_gun01 = 196;
export const FRAME_gun08 = 203;

// Priority Constants
export const ANIM_BASIC = 0;
export const ANIM_ATTACK = 1;
export const ANIM_PAIN = 2;
export const ANIM_DEATH = 3;
export const ANIM_REVERSE = 4; // Used as flag
